export { TunnelAgent } from './agent';
export { loadConfig, type TunnelConfig } from './config';
export { CapabilityRegistry } from './capabilities/index';
export type { Capability, RpcHandler } from './capabilities/index';
export { createFilesystemCapability } from './capabilities/filesystem';
export { createShellCapability } from './capabilities/shell';
export { createDesktopCapability } from './capabilities/desktop';
export { PermissionGuard } from './security/permission-guard';
export type { LocalPermission } from './security/permission-guard';
export { validateCommand } from './security/command-validator';
export { validatePath } from './security/path-validator';
